export enum $task {
  _id = '_id',
  name = 'name',
  description = 'description',
  status = 'status',
  priority = 'priority',
  attachments = 'attachments',
  attachmentFileOriginNames = 'attachmentFileOriginNames',
  projectId = 'projectId',
  taskProjectId = 'taskProjectId',
  createdAt = 'createdAt',
  creatorId = 'creatorId',
  auditFindings = 'auditFindings',
  auditFindingIds = 'auditFindingIds',
  designReviewFindingIds = 'designReviewFindingIds',
  designReviewFindings = 'designReviewFindings',
  issueIntegrationUrl = 'issueIntegrationUrl',
  issueIntegrationKey = 'issueIntegrationKey',
  issueIntegrationStatus = 'issueIntegrationStatus',
  issueIntegrationSummary = 'issueIntegrationSummary',
  issueIntegrationAssignee = 'issueIntegrationAssignee',
  issueIntegrationPriority = 'issueIntegrationPriority',
  pushTaskToIssueTracking = 'pushTaskToIssueTracking',
  issueIntegrationType = 'issueIntegrationType',
  githubProjectId = 'githubProjectId',
  linkedFlaws = 'linkedFlaws',
  lastSynchronized = 'lastSynchronized',
  issueIntegrationSyncStatus = 'issueIntegrationSyncStatus',
  taskIssueIntegration = 'taskIssueIntegration',
  assigneeId = 'assigneeId',
  assignee = 'assignee',
  source = 'source',
  asanaWebhookSecret = 'asanaWebhookSecret',
  unsuccessfullyLinkedIssueIntegrationKey = 'unsuccessfullyLinkedIssueIntegrationKey',
  integrationRequestedBy = 'integrationRequestedBy',
  customLabelId = 'customLabelId',
  externalLink = 'externalLink',
  tenantId = 'tenantId',
  automaticValidationClaim = 'automaticValidationClaim',
  validationRequest = 'validationRequest',
  validationState = 'validationState',
}

export enum $automaticValidationTaskClaim {
  executionId = 'executionId',
  claimedAt = 'claimedAt',
}

export enum $taskValidationRequest {
  zendeskTicketId = 'zendeskTicketId',
  requestedAt = 'requestedAt',
}

export enum $taskExternalLink {
  text = 'text',
  url = 'url',
}

export const TASK_EXTERNAL_LINK_TEXT_MAX_LENGTH: number = 100;
export const TASK_EXTERNAL_LINK_URL_MAX_LENGTH: number = 2048;
export const AUTOMATIC_VALIDATION_CLAIM_TTL_MS: number = 15 * 60 * 1000;

export enum $taskFlaw {
  flaws = 'flaws',
  unmatchedFlaws = 'unmatchedFlaws',
  scanId = 'scanId',
  digitalPropertyId = 'digitalPropertyId',
}

export enum $taskWithTargetStates {
  targetStates = 'targetStates',
}

export enum $taskWithProject {
  project = 'project',
}

export enum TaskStatus {
  backlog = 'backlog',
  newBacklog = 'newBacklog',
  reopened = 'reopened',
  toDo = 'toDo',
  inProgress = 'inProgress',
  requiresReview = 'requiresReview',
  reviewInProgress = 'reviewInProgress',
  done = 'done',
}

/** Every create path and the mongoose default. */
export const TASK_STATUS_ON_CREATE: TaskStatus.newBacklog = TaskStatus.newBacklog;

/** User and machine targets. Inbound mappings may still store backlog; they are translated before this gate. */
export type WritableTaskStatus = Exclude<TaskStatus, TaskStatus.backlog>;

export enum $testingEnvironment {
  staging = 'staging',
  development = 'development',
  production = 'production',
}

export const TESTING_ENVIRONMENTS: Readonly<$testingEnvironment[]> = Object.values($testingEnvironment);

export const EA_STATUSES: Readonly<TaskStatus[]> = Object.freeze([TaskStatus.reviewInProgress, TaskStatus.done]);

export enum TaskPriority {
  low = 'low',
  medium = 'medium',
  high = 'high',
}

export enum TaskCommentType {
  taskAssigned = 'taskAssigned',
  taskUnassigned = 'taskUnassigned',
  taskDeleted = 'taskDeleted',
  error = 'error',
}

export enum $taskComment {
  _id = '_id',
  content = 'content',
  taskId = 'taskId',
  author = 'author',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
  issueIntegrationId = 'issueIntegrationId',
  issueIntegrationKey = 'issueIntegrationKey',
  externalAuthorName = 'externalAuthorName',
  externalDelete = 'externalDelete',
  commentType = 'commentType',
  newAssignee = 'newAssignee',
  previousAssignee = 'previousAssignee',
  integrationType = 'integrationType',
  error = 'error',
  tenantId = 'tenantId',
  edited = 'edited',
}

export enum TaskSource {
  designReview = 'designReview',
  manual = 'manual',
  automated = 'automated',
}

export enum $taskSupport {
  _id = '_id',
  attachments = 'attachments',
  digitalPropertyId = 'digitalPropertyId',
  message = 'message',
  taskId = 'taskId',
  tenantId = 'tenantId',
  userId = 'userId',
  userEmail = 'userEmail',
  workspaceId = 'workspaceId',
}

export const DEFAULT_PUBLIC_TASKS_PAGE_LIMIT = 50;
export const MAX_PUBLIC_TASKS_PAGE_LIMIT = 100;
